import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import styled from 'styled-components';

const FormBox = styled.div`
  border: 2px solid #28a745;
  border-radius: 8px;
  padding: 20px;
  background: linear-gradient(135deg, #f0fff4, #ffffff);
  margin-bottom: 20px;

  h5 {
    color: #28a745;
    margin-bottom: 15px;
    font-weight: 600;
  }
`;

const HelpText = styled.div`
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  font-size: 13px;
  color: #856404;
`;

interface VerbConjugationFormProps {
  formData: any;
  onChange: (data: any) => void;
}

const VerbConjugationForm: React.FC<VerbConjugationFormProps> = ({ formData, onChange }) => {
  const parseContent = () => {
    try {
      return typeof formData.content === 'string' && formData.content
        ? JSON.parse(formData.content)
        : {
            text: '',
            correct_answer: '',
            case_sensitive: false,
          };
    } catch {
      return {
        text: '',
        correct_answer: '',
        case_sensitive: false,
      };
    }
  };

  const [contentData, setContentData] = useState(parseContent());

  useEffect(() => {
    onChange({
      ...formData,
      content: JSON.stringify(contentData),
    });
  }, [contentData]);

  const handleFieldChange = (field: string, value: any) => {
    setContentData({
      ...contentData,
      [field]: value,
    });
  };

  return (
    <FormBox>
      <h5>✏️ Nội dung câu hỏi - Chia động từ trong ngoặc</h5>
      
      <HelpText>
        💡 <strong>Mẹo:</strong> Đặt động từ cần chia trong dấu ngoặc đơn ().
        <br/>
        Ví dụ: "She usually (go) to school by bike."
      </HelpText>

      <FormGroup>
        <Label>Câu hỏi: *</Label>
        <Input
          type="textarea"
          value={contentData.text || ''}
          onChange={(e) => handleFieldChange('text', e.target.value)}
          placeholder="Nhập câu hỏi có động từ trong ngoặc... 
Ví dụ: She usually (go) to school by bike."
          rows={3}
        />
      </FormGroup>

      <FormGroup>
        <Label>Đáp án đúng: *</Label>
        <Input
          type="text"
          value={contentData.correct_answer || ''}
          onChange={(e) => handleFieldChange('correct_answer', e.target.value)}
          placeholder="Ví dụ: goes"
        />
        <small className="form-text text-muted">
          Nhập dạng chia đúng của động từ
        </small>
      </FormGroup>

      <FormGroup check>
        <Label check>
          <Input
            type="checkbox"
            checked={contentData.case_sensitive || false}
            onChange={(e) => handleFieldChange('case_sensitive', e.target.checked)}
          />
          {' '}
          <span style={{ fontSize: '14px' }}>
            Phân biệt chữ hoa/thường (case sensitive)
          </span>
        </Label>
      </FormGroup>

      {/* Preview JSON */}
      <details style={{ marginTop: '15px' }}>
        <summary style={{ cursor: 'pointer', color: '#666', fontSize: '14px' }}>
          🔍 Xem JSON (Debug)
        </summary>
        <pre style={{ 
          background: '#f5f5f5', 
          padding: '10px', 
          borderRadius: '4px',
          fontSize: '12px',
          maxHeight: '200px',
          overflow: 'auto',
          marginTop: '10px'
        }}>
          {JSON.stringify(contentData, null, 2)}
        </pre>
      </details>
    </FormBox>
  );
};

export default VerbConjugationForm;
